/**
 * The external dependencies.
 */


export const getErrorreports = ({quality: {errorreports}}) => errorreports;

export const getCurrentError = ({quality: {current}}) => current;

export const getCurrentErrorDetails = ({quality: {errorDetails}}) => errorDetails;

export const getErrorTracking = ({quality: {errorDetails}}) => errorDetails.tasktrackingEntityList;





// WEBPACK FOOTER //
// ./src/store/quality/selectors.js